import { render, staticRenderFns } from "./userRecord.vue?vue&type=template&id=cb7bf372&scoped=true&"
import script from "./userRecord.vue?vue&type=script&lang=js&"
export * from "./userRecord.vue?vue&type=script&lang=js&"
import style0 from "./userRecord.vue?vue&type=style&index=0&id=cb7bf372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7bf372",
  null
  
)

export default component.exports